import cn from 'classnames';
import { Box } from 'reakit';

import Link from '@/components/link';

interface BadgeProps {
  slug?: string;
  title: string;
  variant?: 'primary' | 'secondary' | 'default';
  className?: string;
  as?: 'link' | 'text';
}

const variants = {
  primary: `text-cornflower bg-faded-cornflower`,
  secondary: `text-white bg-zodiac`,
  default: `text-zodiac bg-white border border-primary-100 hover:text-white hover:bg-zodiac`,
};

export default function Badge({
  slug,
  title,
  variant = `default`,
  className,
  as = `link`,
}: BadgeProps) {
  return (
    <p
      className={cn(
        `inline-block text-xs leading-[22px] font-medium rounded transition-colors duration-200`,
        variants[variant],
        className,
      )}
    >
      <Box
        as={as === `link` ? Link : `span`}
        {...(as === `link` && { href: slug })}
        className="text-[color:inherit] w-full h-full block px-2"
      >
        {title}
      </Box>
    </p>
  );
}
